import Phaser from "phaser";

export class EmptyScreen {
  private container: Phaser.GameObjects.Container;

  constructor(scene: Phaser.Scene, parent: Phaser.GameObjects.Container) {
    this.container = scene.add.container(0, 0);
    parent.add(this.container);
    this.container.setVisible(false);
  }

  show() {
    this.container.setVisible(true);
  }

  hide() {
    this.container.setVisible(false);
  }

  destroy() {
    this.container.destroy();
  }
}
